import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { renderCheckbox } from './Fields';
import validate from './validation'
import Dropzone from 'react-dropzone';


class CasoFormStep4 extends Component{
    constructor(props) {
        super(props);
        this.state = {
            nofotos: this.props.summary.nofotos || false,
            noradios: this.props.summary.noradios || false,
            nodicoms: this.props.summary.nodicoms  || false,
            fotos: [],
            radios: [],
            dicoms: []
        }
    }
    renderField(field){
        return(
            <div className="form-group">
                <label>{field.label}</label>
                <input
                    className="form-control"
                    type={field.type}
                    {...field.input}
                />
            </div>
        )
    }
    renderDropzoneInput(field){
        return (
            <div className="dropzone-container">
                {field.meta.touched && field.meta.error && <span className="text-danger">{field.meta.error}</span>}
                <Dropzone
                    className="dropzone"
                    name={field.name}
                    onDrop={( filesToUpload, e ) => {
                        let files = this.state[field.input.name];
                        files = [...files, ...filesToUpload];
                        this.setState({[field.input.name]: files})
                        field.input.onChange(files);
                    }}
                >
                    <div>Haz click o arrastra los archivos que deseas incluir.</div>
                </Dropzone>
                {this.state[field.input.name] && Array.isArray(this.state[field.input.name]) && (
                    <ul>
                        { this.state[field.input.name].map((file, i) => <li key={i}>{file.name}</li>) }
                    </ul>
                )}
            </div>
        );
    }
    render(){
        return(
            <form onSubmit={this.props.handleSubmit}>
                <h4>
                    Fotografías
                    <Field
                        col="form-check-inline float-right"
                        name="nofotos"
                        component={renderCheckbox}
                        label="Autorizo expresamente que se realice el estudio sin aportar fotografías del paciente"
                        id="nofotos"
                        onChange={()=>{
                            this.setState({nofotos: !this.state.nofotos})
                        }}
                    />
                </h4>
                {!this.state.nofotos &&
                    <Field
                        name="fotos"
                        component={this.renderDropzoneInput.bind(this)}
                    />
                }
                <h4>
                    Radiografías
                    <Field
                        col="form-check-inline float-right"
                        name="noradios"
                        component={renderCheckbox}
                        label="Autorizo expresamente que se realice el estudio sin aportar radiografías del paciente"
                        id="noradios"
                        onChange={()=>{
                            this.setState({noradios: !this.state.noradios})
                        }}
                    />
                </h4>
                {!this.state.noradios &&
                    <Field
                        name="radios"
                        component={this.renderDropzoneInput.bind(this)}
                    />
                }
                <h4>
                    DICOM o STL
                    <Field
                        col="form-check-inline float-right"
                        name="nodicoms"
                        component={renderCheckbox}
                        label="Autorizo expresamente que se realice el estudio sin aportar archivos DICOM y/o STL del paciente"
                        id="nodicoms"
                        onChange={()=>{
                            this.setState({nodicoms: !this.state.nodicoms})
                        }}
                    />
                </h4>
                {!this.state.nodicoms &&
                    <Field
                        name="dicoms"
                        component={this.renderDropzoneInput.bind(this)}
                    />
                }
                <div className="form-actions">
                    <button type="submit" onClick={this.props.previousPage} className="btn btn-secondary next">
                        <i className="fa fa-chevron-left"></i>
                        &nbsp; Anterior
                    </button>
                    <button type="submit" className="btn btn-primary next float-right">
                        Siguiente &nbsp;
                        <i className="fa fa-chevron-right"></i>
                    </button>
                </div>
            </form>
        )
    }
}
export default reduxForm({
    form: 'wizard', //                 <------ same form name
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate,
})(CasoFormStep4);



// WEBPACK FOOTER //
// ./resources/assets/js/components/forms/newcaso/CasoFormStep4.jsx